/* eslint-disable import/no-duplicates */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '@components/common/Loader/newLoaderModal';
import Modal from '@components/common/Modal';
import LoginKeyboard from '@components/common/formElements/SimpleKeyboard/loginKeyboard';
import { login, closeEmployeeCheck } from '@reducers/oauth';
import { toggleOtherPaymentOptionFalse } from '@reducers/payment';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { removeSeat, updateSeatInfo } from '@reducers/orders';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { flowType } from '@utility/userInfo';
import { getObjectValue, playRingtone } from '@utility/helperFunction';
import EventEmitter from '@utility/eventSubscribers';
import Ringtone from '@assets/tones/beep-08b.mp3';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { APP_CONFIG } from '@constants';
import { isEmpty } from 'lodash';
import { urlSearchParams } from '@utility/utills';
import FullWidthModal from '../common/Modal/FullWidthModal';
import {
  handleLoyaltyInfo,
} from '@reducers/loyalty';
import cn from 'classnames';

const EmployeeCheck = props => {
  // Props Destructuring
  const { isEmployeeCheck, callBack, caseType, customClass2, auth, handleCloseCaseType, handleLoyaltyInfo, isLandScape  } = props;

  const [isSwipe, setIsSwipe] = useState(false);
  const isServerApp = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';

  // Methods

  const routeBackTo = () => {
    switch (caseType) {
      case 'cashCheck':
      case 'tableTop':
        callBack();
        break;
      case 'kiosk':
        callBack();
        break;
      case 'paymentTerminal':
        callBack();
        break;
      default:
        if (
          ['32', '33'].includes(urlSearchParams('screenType')) &&
          props?.seat?.paymentCheck?.tickets?.length > 0
        ) {
          if (props.deviceInfo?.deviceGroup?.brandSurveyId) {
            if (
              props.seat?.paymentCheck?.tickets?.length > 0 &&
              props.seat?.paymentCheck?.tickets[
                props.seat?.paymentCheck?.tickets?.length - 1
              ].paymentTypeName === 'Cash'
            ) {
              props.setPaymentType(22);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=22&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            } else {
              props?.getSurveyResponse();
              props?.setPaymentType(11);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.id
                }?ticketSplitTypeId=${Number(
                  urlSearchParams('ticketSplitTypeId')
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=11&type=${urlSearchParams('type')}&flow=reverse`,
                { replace: true }
              );
            }
          } else {
            props?.setPaymentType(22);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=22&type=${urlSearchParams('type')}&flow=reverse`,
              { replace: true }
            );
          }
        } else {
          props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
            replace: true,
          });
          props.removeSeat();
          if (window.ReactNativeWebView && (isServerApp || isTableTop)) {
            EventEmitter.changeOrientation({
              orientation: 'landscape',
            });
          }
        }
        break;
    }
  };

  const handleRouteToChecKListing = () => {
    props.closeEmployeeCheck();
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      false
    );
    if (authResponse) {
      window.sessionStorage.removeItem('tipAmt');
      window.sessionStorage.removeItem('payAmt');
      routeBackTo();
    } else {
      routeBackTo();
    }
  };

  const handleClose = () => {
    handleCloseCaseType();
    props.closeEmployeeCheck();
    if (['31'].includes(urlSearchParams('screenType'))) {
      props.toggleOtherPaymentOptionFalse();
    }
  };

  const onSubmit = (data, empCard) => {
    setIsSwipe(false);
    if (!props.deviceInfo) {
      props.setErrorPopUp({
        res: 'Device information is not available. Please refresh the page.',
      });
      return;
    }
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: props.deviceInfo.deviceId,
      employeeCode: data.employeeCode,
      employeeCard: empCard || null,
    };
    props
      .login(dataToSend)
      .then(() => {
        handleRouteToChecKListing();
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleStopMagneticRead = () => {
    EventEmitter.stopMagneticCardRead();
    EventEmitter.sendMessage(
      { type: 'stopMagCard' },
      () => {
        console.log('success');
      },
      () => {
        console.log('failure');
      }
    );
    setIsSwipe(false);
  };

  const initializeIngenico = () => {
    try {
      EventEmitter.scanIngenicoDevice(
        res => {
          onSubmit({}, res);
        },
        () => {
          handleStopMagneticRead();
        }
      );
      EventEmitter.sendMessage(
        { type: 'scanMagCard' },
        () => {
          console.log('success');
        },
        () => {
          console.log('failure');
        }
      );
    } catch (e) {
      console.log('catch', e);
    }
  };

  const cardReader = () => {
    playRingtone(Ringtone);
    setIsSwipe(true);
    initializeIngenico();
  };

  const validateLogin = data => {
    return new Promise((resolve, reject) => {
      const error = {};
      if (!data.employeeCode) {
        error.employeeCode = '';
        props.setErrorPopUp({
          res: CUSTOM_MESSAGES().EMPLOYEE_CODE_IS_REQUIRED,
          noErrorTxt: true,
        });
      }
      if (isEmpty(error)) {
        resolve();
      } else {
        reject(new Error(error.employeeCode));
      }
    });
  };
  const stationName =
    props.seat?.stationName?.length > 8
      ? props.seat?.stationName?.substring(0, 8).concat('...')
      : props.seat.stationName || props.seat.stationNumber;

  // HTML CSS CODE

  return (
    <>
      {props.loading && <Loader />}
      <FullWidthModal
        isOpen={isEmployeeCheck}
        customClass2={customClass2 || 'h-100'}
        style={{
          backgroundColor: props?.serverAppTheme?.popUp_bg,
          boxShadow: props?.serverAppTheme?.popUp_box_shadow,
          height: '100%',
        }}
      >
        <div className={cn('col-12 fw-600 fs_18 d-flex pt-3 px-3')}>
          <div className={'fs_18 fw-600 col-6 p-0 text-left'}>
            {props.seat?.tab ? 'Tab' : 'Table'} {stationName}
          </div>
          <div className={'fs_18 fw-600 col-6 p-0 text-right'}>
            # {props?.seat?.number}
          </div>
        </div>
        <div
          className={cn(
            isLandScape
              ? !props.isOtherPaymentOption ||
                ["12", "32", "4", "28", "16", "22", "31"].includes(
                  urlSearchParams("screenType"),
                )
                ? (props.isOtherPaymentOption &&
                  ['31'].includes(urlSearchParams('screenType')) ? "h-77" : "h-83")
                : "h-80"
              : "px-3 pb-3 h-97",
            "d-flex justify-content-center align-items-center text-center position-relative",
          )}
          style={{ color: props?.serverAppTheme?.primary_text }}
        >
          <LoginKeyboard
            containerClass="w-100"
            name="employeeCode"
            validate={validateLogin}
            isKioskMode={['kiosk'].includes(flowType())}
            buttonName={
              ['kiosk'].includes(flowType())
                ? LABEL().KIOSK_SUBMIT
                : !props.deviceInfo?.deviceGroup?.serverAppSettings
                  ?.enableLoginWithCard &&
                  props.deviceInfo?.deviceGroup?.serverAppSettings
                    ?.disableLoginWithKeypad
                  ? ''
                  : props.deviceInfo?.deviceGroup?.serverAppSettings
                    ?.disableLoginWithKeypad
                    ? LABEL().CLICK_TO_SWIPE_CARD
                    : LABEL().SUBMIT
            }
            closeBtn={
              ['kiosk'].includes(flowType())
                ? LABEL().KIOSK_CLOSE
                : LABEL().CLOSE
            }
            placeholder={CUSTOM_MESSAGES().ENTER_EMPLOYEE_CODE}
            onSubmit={onSubmit}
            handleClose={handleClose}
            type="number"
            isEmployeeCheck={
              flowType() === 'serverApp' ||
                flowType() === 'paymentTerminal' ||
                flowType() === 'kiosk'
                ? !isEmployeeCheck
                : isEmployeeCheck
            }
            goToSwiper={cardReader}
            auth={auth}
            serverAppTheme={props?.serverAppTheme}
            LockIconPopUp={true}
            employeeCheck
            isOtherPaymentOptionLogin={
              props.isOtherPaymentOption &&
              ['31'].includes(urlSearchParams('screenType'))
            }
            handleLoyaltyInfo={handleLoyaltyInfo}
            isLandScape={props.isLandScape}
          />
        </div>
      </FullWidthModal>
      <Modal
        isOpen={isSwipe}
        isModalCenter
        style={{
          margin: 'auto',
          width: '90%',
          backgroundColor: props?.serverAppTheme?.popUp_bg,
          border: props?.serverAppTheme?.popupBorder,
          boxShadow: props?.serverAppTheme?.popUp_box_shadow,
        }}
      >
        <div
          className="row mb-0"
          style={{ color: props?.serverAppTheme?.primary_text }}
        >
          <div
            className="col-12 fs-18  mt-20 mb-20 justify-content-center align-items-center text-center "
            style={{ fontFamily: 'Poppins' }}
          >
            Please swipe the card after the beep
          </div>
          <div
            className="col-12 fs-14 mt-20 mb-20 justify-content-center align-items-center text-center"
            style={{ fontFamily: 'Poppins' }}
          >
            <button
              className="btn "
              style={{
                border: props?.serverAppTheme?.cancleBtn_Border,
                background: props?.serverAppTheme?.OFF_Premise_Btn,
                color: props?.serverAppTheme?.primary_text,
              }}
              type="button"
              onClick={() => {
                setIsSwipe(false);
                handleStopMagneticRead();
              }}
            >
              {LABEL().CANCEL}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

// Redux Part

const mapStateToProps = ({ oauth, payment, theme }) => ({
  loading: oauth.loading,
  userInfo: oauth.loggedInUserData,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  isEmployeeCheck: oauth.isEmployeeCheck,
  authResponse: payment.authResponse,
  serverAppTheme: theme.serverAppTheme,
  isOtherPaymentOption: payment.isOtherPaymentOption,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login,
      setNotification,
      closeEmployeeCheck,
      removeSeat,
      updateSeatInfo,
      updateChecksAfterResponse,
      setErrorPopUp,
      toggleOtherPaymentOptionFalse,
      handleLoyaltyInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCheck);
